<template>
  <div class="tags">
    <popper
      style="margin-right: 0.5rem"
      trigger="hover"
      :options="{
        placement: 'top',
        modifiers: { offset: { offset: '0,5px' } }
      }"
      v-if="isBlockedStatus"
    >
      <div class="popper is-warning has-text-left exam-status-hint ws-popper">
        <b>Экзамен заблокирован</b>
        <ul>
          <li class="has-text-danger">
            <ws-icon name="close" color="#EB5757" width="16" height="16" />
            <span>{{ $t("Причина: ") }}{{ exam.blocking_comment }}</span>
          </li>
        </ul>
      </div>
      <div
        class="tag is-outlined has-text-weight-bold is-danger"
        slot="reference"
      >
        <span
          class="is-uppercase"
          v-text="
            isExam50Plus
              ? $t(`exam.status.50plus.${exam.status}`)
              : $t(`exam.status.${exam.status}`)
          "
        ></span>
      </div>
    </popper>
    <div
      v-else
      class="tag is-outlined has-text-weight-bold"
      :class="{
        'is-success':
          isExam50Plus ||
          exam.status === constants.exam_status.COMPLETE_MAIN_EXPERT,
        'is-warning':
          !isExam50Plus &&
          exam.status !== constants.exam_status.COMPLETE_MAIN_EXPERT,
        'is-danger':
          exam.status === constants.exam_status.APPROVED_MAIN_EXPERT
      }"
    >
      <span
        class="is-uppercase"
        v-text="
          isExam50Plus
            ? $t(`exam.status.50plus.${exam.status}`)
            : $t(`exam.status.${exam.status}`)
        "
      ></span>
    </div>
    <div
      v-if="exam.main_expert && exam.main_expert.accepted"
      class="tag is-outlined is-success has-text-weight-bold"
    >
      <span
        class="is-uppercase"
        v-text="isExam50Plus ? 'ГЭ назначен' : 'ГЭ утвержден'"
      ></span>
    </div>
    <div
      v-if="
        exam.experts &&
          exam.experts.length &&
          !exam.experts.find(e => e.accepted)
      "
      class="tag is-outlined is-warning has-text-weight-bold"
    >
      <span
        class="is-uppercase"
        v-text="isExam50Plus? 'Эксперты добавлены' : 'Эксперты назначены'"
      ></span>
    </div>
    <div
      v-if="exam.experts && exam.experts.find(e => e.accepted)"
      class="tag is-outlined is-success has-text-weight-bold"
    >
      <span
        class="is-uppercase"
        v-text="isExam50Plus ? 'Эксперты назначены' : 'Эксперты утверждены'"
      ></span>
    </div>
    <template v-for="(flag, index) in getFlags(exam.flags)">
      <b-tooltip class="tooltip-tag" :key="index" v-if="$te(`exam.flags.shot.${flag}`)" :label="$t(`exam.flags.shot.${flag}`)">
        <div
          class="tag is-violet exam-flag is-outlined has-text-weight-bold"
          :class="`tag-${flag}`"
        >
          <span class="is-uppercase" v-text="$t(`exam.flags.${flag}`)"></span>
        </div>
      </b-tooltip>
      <div
        v-else
        class="tag is-violet exam-flag is-outlined has-text-weight-bold"
        :class="`tag-${flag}`"
        :key="index"
      >
        <span class="is-uppercase" v-text="$t(`exam.flags.${flag}`)"></span>
      </div>
      <!-- <div
        class="tag is-violet exam-flag is-outlined has-text-weight-bold"
        :class="`tag-${flag}`"
        :key="flag"
        v-if="intermediateFlags.includes(flag)"
      >
        <span class="is-uppercase" v-text="'Промежуточная аттестация'"></span>
        <span class="is-uppercase" v-text="$t(`exam.flags.${flag}`)"></span>
      </div> -->
    </template>
  </div>
</template>

<script>
import Popper from 'vue-popperjs'
import isBlockedExam from '@/mixins/is-blocked-exam.mixin'
import { constants } from '@/services/constants.service'
export default {
  name: 'WsDemoExamStatus',
  components: { popper: Popper },
  mixins: [isBlockedExam],
  props: {
    exam: Object
  },
  data () {
    return {
      constants,
      intermediateFlags: ['total', 'intermediate', 'de_level_intermediate_certification']
    }
  },
  computed: {
    isExam50Plus () {
      return (
        this.exam.flags.indexOf('50_plus') > -1 ||
            this.exam.flags.indexOf('master_of_industrial_edu') > -1
      )
    }
  },
  methods: {
    getFlags (flags) {
      if (flags) {
        let arr = flags.slice(0)
        let secondaryDegreeIndex = arr.indexOf('secondary_degree')
        if (secondaryDegreeIndex > -1) {
          arr.unshift(arr.splice(secondaryDegreeIndex, 1)[0])
        }
        let universityDegreeIndex = arr.indexOf('university_degree')
        if (universityDegreeIndex > -1) {
          arr.unshift(arr.splice(universityDegreeIndex, 1)[0])
        }
        let fgosIndex = arr.indexOf('state_standard')
        if (fgosIndex > -1) {
          arr.unshift(arr.splice(fgosIndex, 1)[0])
        }
        const notStateStandardIndex = arr.indexOf('not_state_standard')
        if (notStateStandardIndex > -1) {
          arr.splice(notStateStandardIndex, 1)
        }
        const regionalIndex = arr.indexOf('regional_exam')
        if (regionalIndex > -1) {
          arr.splice(regionalIndex, 1)
        }
        const remoteMainExpert = arr.indexOf('main_expert_is_remote')
        if (remoteMainExpert > -1) {
          arr.splice(remoteMainExpert, 1)
        }
        return arr
      }
    }
  }
}
</script>

<style scoped>
.tooltip-tag{
  margin-right: 0.5rem;
}
</style>
